import React from 'react'

// Hook
export default function useLocalStorage(key: string, initialValue: any) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = React.useState(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key)
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      // If error also return initialValue
      console.log(error)
      return initialValue
    }
  })

  const valueRef = React.useRef(storedValue)

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = React.useCallback(
    (value: any) => {
      try {
        const currentValue = valueRef.current
        // Allow value to be a function so we have same API as useState
        const valueToStore =
          value instanceof Function ? value(currentValue) : value
        // Save state
        setStoredValue(valueToStore)
        valueRef.current = valueToStore
        // Save to local storage
        window.localStorage.setItem(key, JSON.stringify(valueToStore))
      } catch (error) {
        // A more advanced implementation would handle the error case
        console.log(error)
      }
    },
    [key, setStoredValue],
  )

  return [storedValue, setValue]
}
